import Api from '../config/api';

export const refazerTexto = (texto) => {
  return Api.post('', {
    query: `mutation ($texto: String!) {
      refazerTexto(texto: $texto) {
        textoRefeito
      }
    }`,
    variables: { texto },
  });
};